/**
 * jQuery.ScrollableTab - Scrolling multiple tabs.
 * @copyright (c) 2010 Astun Technology Ltd - http://www.astuntechnology.com
 * Dual licensed under MIT and GPL.
 * Date: 28/04/2010
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com | http://www.aamirafridi.com
 * @version 1.0
 */
 /*  HEAVILY MODIFIED BY RK CONSULTING */
 /*
 *
 * 	12/27/2011 - modified .clicks in PreviousTab and NextTab to click only the first <a>,
 * 				 we add <a>'s for the close and lock icons, these should not be clicked in PreviousTab and NextTab
 */
 (function( $, undefined ) { // jQuery noConflict compliant
    $.widget("rk.scrollableTabs", {
        version : "@VERSION",
        options : {
           animationSpeed   : 100,
           resizable        : false,
           easing           : 'swing',
           closable         : false
        },
        // Setus up the widget!
        _create : function () {
            var me = this,
                tabsNav = me._getTabsNav(),
                li = $('li', tabsNav),
                tabsWidth = me.width(li),
                nav,
                wrapperWidth = me.element.parent().width();
                
                
                
            
            me.element.wrap('<div id="stTabswrapper" style="position:relative; overflow: hidden;"/>')
                      .find('.ui-tabs-nav')
                      .css({ 
                          width : (tabsWidth > wrapperWidth) ? tabsWidth : wrapperWidth,
                          position : 'relative'
                      });
                      
            
                 
            
            var tabsWrapper = me.element.parents('#stTabswrapper').width('100%'),
                arrowsTopMargin = (parseInt(parseInt(tabsNav.innerHeight()/2)-8)),
                arrowsCommonCss = {
                    cursor      : 'pointer',
                    'z-index'   : 3,
                    'position'  : 'absolute',
                    'top'       : 3,
                    'height'    : tabsNav.outerHeight() - ($.browser.safari ? 2 : 1)
                },
                resizableDefaults = {
                    minWidth    : tabsWrapper.width(),
                    maxWidth    : tabsWrapper.width() * 2,
                    minHeight   : tabsWrapper.height(),
                    maxHeight   : tabsWrapper.height() * 2,
                    handles     : "e,s,se"
                    
                };
                
           
            if (me.option('resizable')) {
                var resizableOptions = this.option('resizable');
                if ( typeof resizableOptions == 'object' ) {
                    resizableOptions = $.extend({}, resizableDefaults, resizableOptions);
                    resizableOptions = $.extend(resizableOptions, {
                        alsoResize  : me.element,
                        resize      : me.onResize.proxy(this),
                        start       : me.onResizeStart.proxy(this),
                        stop        : me.onResizeStop.proxy(this)
                    });
                }
                if ($.fn.resizable) {
                    tabsWrapper.resizable(resizableOptions);
                } else {
                    alert('Can\'t activate resize. jQuery widget ui resizable is not available.');
                }
            }
            
            
            tabsWrapper.prepend(
                nav = $('<div/>')
                    .disableSelection()
                    .css({'position':'relative','z-index':100,'display':'none'})
                    .append(
                        $('<span/>')
                            .disableSelection()
                            .attr('title','Previous tab')
                            .css(arrowsCommonCss)
                            .addClass('ui-state-active ui-corner-tl ui-corner-bl stPrev stNav')
                            .css('left',3)
                            .append($('<span/>').disableSelection().addClass('ui-icon ui-icon-carat-1-w').html('Previous tab').css('margin-top',arrowsTopMargin))
                            .click(function(event){
                                
                                //Check if disabled
                                if ($(event.currentTarget).hasClass('ui-state-disabled')) {
                                    return false;
                                } 
                                //Just select the previous tab and trigger scrollToTab event
                                var prevIndex = tabsNav.find('li.ui-tabs-selected').prevAll().length-1;
                                //Now select the tab
								// 12/27/2011 - rellis - add .first() so the Close button, which is an <a>, is not clicked
                                tabsNav.find('li').eq(prevIndex).find('a').first().trigger('click');
                                
                                return false;
                            }.bind(this)),
                            $('<span/>')
                                .disableSelection()
                                .attr('title','Next tab')
                                .css(arrowsCommonCss)
                                .addClass('ui-state-active ui-corner-tr ui-corner-br stNext stNav')
                                .css({'right':3})
                                .append($('<span/>').addClass('ui-icon ui-icon-carat-1-e').html('Next tab').css('margin-top',arrowsTopMargin))
                                .click(function(){
                                    
                                    var nextIndex = tabsNav.find('li.ui-tabs-selected').prevAll().length+1;
                                    //Now select the tab
									// 12/27/2011 - rellis  - add .first() so the Close button, which is an <a>, is not clicked
                                    tabsNav.find('li').eq(nextIndex).find('a').first().trigger('click');
                                    
                                    return false;
                                }.bind(this))
                    )
            );
            
            me._addCloseButton();
            me.element.data("nav", nav);
            me.element.data("tabsWrapper", tabsWrapper);
            me.element.data("wrapperWidth", wrapperWidth);
            me.element.bind("tabsselect", me._checkNav.bind(this));
            me.element.bind("tabsselect", me._slideTo.bind(this));
            me.element.bind("tabsadd", this._onAddTabs.bind(this));
        },
       
        // Use the _setOption method to respond to changes to options
        _setOption : function( key, value ) {
            var me = this;
            
            switch( key ) {
                case "closable":
                    me._addCloseButton();
                    break;
            }
            
            
            $.Widget.prototype._setOption.apply( this, arguments );
        },
        
        _destroy : function() {
            
        },
        
        onResize : function (event, ui) {
            var me = this;
            me._trigger("resize", event);
        },
        
        onResizeStart : function (event, ui) {
            var me = this;
            me._trigger("resizestart", event);
        },
        
        onResizeStop : function (event, ui) {
            var me = this;
            me._trigger("resizestop", event);
        },
        widths  : new Array(),
        width   : function (el) {
            
            var me = this,
                size,
                totalWidth = 0;
            
            if (typeof el === 'object' && el.length == 0) {
                return 0;
            }
            
            if (el.size) {
                size = el.size();
            } else {
                size = 0;
            }
            
            if (size > 1) {
                el.each(function(index, element){
                    
                    var elementWidth = $(element).outerWidth();
                              
                    totalWidth += elementWidth;
                });
                
                totalWidth += 100;
            } else {
                totalWidth = $(el[0]).outerWidth();
            }
            
            return totalWidth;
        },
        _onAddTabs : function (event, ui) {
            var me = this;
            
            me._expandULSize.call(this);
            me._checkNav.call(this, event, ui);
            me._addCloseButton.call(this);
            me.element.tabs("select", ui.index);
            
        },
        _expandULSize : function () {
            var me = this,
                tabsNav = me._getTabsNav(),
                navSize = tabsNav.outerWidth(),
                li = $('li', tabsNav),
                tabsWidth = me.width(li);
                
                tabsNav.css({width : (tabsWidth > navSize) ? tabsWidth : navSize});
                
        },
        _checkNav : function (event, ui) {
            // don't want it going back up again.
            event.stopPropagation();
            var me = this,
                tabsNav = me._getTabsNav(),
                navSize = tabsNav.width(),
                wrapperWidth = me.element.data("wrapperWidth"),
                nav = me.element.data("nav"),
                li = $('li', tabsNav),
                tabsWidth = me.width(li);
                
                if (tabsWidth > wrapperWidth) {
                    nav.show();
                }
            
                var tabsWrapper = me.element.data('tabsWrapper'),
                    $ntNav = tabsWrapper.find('.stNext'),
                    $pvNav = tabsWrapper.find('.stPrev');
                
                if(ui.index == li.size() - 1)
                {
                    $pvNav.removeClass('ui-state-disabled');
                    $ntNav.addClass('ui-state-disabled');
                }
                else if(ui.index == 0)
                {
                    $ntNav.removeClass('ui-state-disabled');
                    $pvNav.addClass('ui-state-disabled');
                }
                else
                {
                    $ntNav.removeClass('ui-state-disabled');
                    $pvNav.removeClass('ui-state-disabled');
                }
            
        },
        _addCloseButton : function () {
            var me = this,
                tabsNav = me.element.find('ul.ui-tabs-nav').first(),
                closeTopMargin = parseInt(parseInt(tabsNav.find('li:first').innerHeight()/2,10)-8),
                closables = me.option('closable');;
                
            if (closables === false) {
                return;
            }
            
            me.element.find('.ui-tabs-nav li').each(function(index, el){
                
                // This is for individual tabs that should be closable.
                // If the index or id of the tab is not within the array. The user
                // will NOT be able to close the tab.
                if ($.isArray(closables) && ($.inArray($(el).find('a').attr('href'), closables) === -1)) {
                    return;
                }
                
                // Already has the close button, so skip it.
                if ($(this).find('.ui-tabs-close').length >= 1) {
                    return;
                }
                
                $(this).disableSelection().append(
                    $('<span>').css({
                        'float'     : 'left',
                        'cursor'    : 'pointer',
                        'margin'    : closeTopMargin + 'px 2px 0 -11px'
                    })
                    .addClass('ui-tabs-close ui-icon ui-icon-close')
                    .attr('title','Close this tab')
                    .click(function() {
                        
                        me.element.tabs('remove', $(this).parents('li').prevAll().length);
                        if (me.element.tabs("length") == 1) {
                            me.element.find('.ui-icon-close').hide();
                        } else {
                            me.element.find('.ui-icon-close').show();
                        }
                    })
                );
                
                tabsNav.find('.ui-icon-close').show();
            });
        },
        _slideTo : function (event, ui) {
            
            // find the selected index
            var me = this,
                nav = me.element.data('nav'),
                navWidth = nav.is(':visible') ? nav.find('.stPrev').outerWidth(true) : 0,
                index = ui.index,
                wrapperWidth = me.element.data("wrapperWidth"),
                tabsNav = me.element.find('ul.ui-tabs-nav').first(),
                tabClicked = $(ui.tab).parents('li'),
                current = tabClicked.width(),
                currentWidth = tabClicked.outerWidth(),
                prevAll = tabsNav.find('li').eq(index).prevAll(),
                left = tabsNav.position().left,
                prevAllWidth = me.width(prevAll),
                offsetLeft, hiddenSide;
                
            
                
            if ((tabClicked.position().left + tabClicked.outerWidth()) > (this.element.width() + navWidth) ) {
               hiddenSide = 'right';
            } else if (tabClicked.position().left + left < 0) {
               hiddenSide = 'left';
            }
            
           
            
            offsetLeft = (wrapperWidth - (tabClicked.position().left + tabClicked.outerWidth() + navWidth));
            offsetLeft = (hiddenSide == 'left') ? -(tabClicked.position().left) : offsetLeft;
             
           
            
            if ((tabClicked.position().left + tabClicked.outerWidth() < wrapperWidth  && (tabClicked.position().left + left > 0)) ) {
                // Do nothing
               
            } else {
                tabsNav.animate({left : offsetLeft + 'px'}, me.option('animationSpeed'), me.option('easing'));
            }
            
        },
        setcss : function () {
            
            var me = this,
                arglen = arguments.length,
                css, cssname, id,
                tabsNav = me._getTabsNav(),
                tab, cssvalue;
                
            
            switch (arglen) {
                case 3:
                    cssname     = arguments[0];
                    cssvalue    = arguments[1];
                    id          = arguments[2];
                    
                    // see if the id starts with a #
                    if (/^#/.test(id)) {
                        tab = tabsNav.find('li').find('a[href="'+ id + '"]');
                    } else {
                        alert(id + ' doesn\'t appear to be a valid Id.');
                    }
                    
                    tab.find('a').css(cssname, cssvalue);
                    break;
                case 2:
                    css = arguments[1];
                    id  = arguments[0];
                    
                    // see if the id starts with a #
                    if (/^#/.test(id)) {
                        tab = tabsNav.find('li').find('a[href="'+ id + '"]');
                    } else {
                        alert(id + ' doesn\'t appear to be a valid Id.');
                    }
                    
                    tab.css(css);
                default:
                    break;
            }
        },
        _getTabsNav : function () {
            var me = this;
            
            return me.element.find('ul.ui-tabs-nav').first();
        },
        _findTabByIndex : function (index) {
            var me = this;
            
            return me._getTabsNav().find('li').eq(index);
        }
    });
})( jQuery );